// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-overlay[data-v-7ca50a30]{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.7);z-index:1000;backdrop-filter:blur(2px);padding-top:20px;transition:opacity .15s ease-out;opacity:0}.search-overlay.visible[data-v-7ca50a30]{opacity:1}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
